import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ChatIcon({
  size,
  color,
  style,
  noFill,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      color={color}
      style={style}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.926 19.2096V16.1823H1.632C0.730858 16.1823 0 15.4451 0 14.5361V1.64527C0 0.737027 0.731081 0 1.632 0H18.369C19.2699 0 20 0.736972 20 1.64527V14.5361C20 15.4451 19.2701 16.1823 18.369 16.1823H11.2904L6.16177 19.8534C5.64316 20.2235 4.926 19.8505 4.926 19.2096ZM5.426 15.1736C5.70214 15.1736 5.926 15.3994 5.926 15.678V18.7852L10.8417 15.2666C10.9262 15.2061 11.0273 15.1736 11.131 15.1736H18.369C18.7175 15.1736 19 14.8883 19 14.5361V1.64527C19 1.29395 18.7174 1.00875 18.369 1.00875H1.632C1.28323 1.00875 1 1.29428 1 1.64527V14.5361C1 14.888 1.28314 15.1736 1.632 15.1736H5.426Z'
      />
    </svg>
  );
}
